import React from "react";
import { CajaRow3 } from "../../../../../components/cajaRow3/CajaRow3";

export const EstatusItem = ({ estatus }) => {
  const { estatusFinal, cantidad, monto } = estatus;
  return <CajaRow3 nombre={estatusFinal} cantidad={cantidad} monto={monto} />;
};
